module.exports = __webpack_public_path__ + "static/media/bg-mletter-header.5c103214.png";